import {
  CalendarToday,
  LocationSearching,
  MailOutline,
  PermIdentity,
  PhoneAndroid,
  Publish,
} from "@material-ui/icons";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  updateDoc,
  doc,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../../firebase";
import "./user.css";

export default function User() {
  const [oneTask, setOneTask] = useState([]);

  //Fetch Data When Page Loads
  useEffect(() => {
    const taskColRef = query(
      collection(db, "users"),
      orderBy("created", "desc")
    );

    onSnapshot(taskColRef, (snapshot) => {
      setOneTask(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }))
      );
    });
  }, []);
  return (
    <div className="user">
      <div className="userTitleContainer">
        <h1 className="userTitle">Edit User</h1>
      </div>
      <div className="userContainer">
        <div className="userShow">
          {oneTask.map((task) => (
            <div className="userShowBottom">
              <span className="userShowTitle">Account Details</span>
              <div className="userShowInfo">
                <PermIdentity className="userShowIcon" />
                <span className="userShowInfoTitle">
                  User Name: {task.data.username}
                </span>
              </div>
              <div className="userShowInfo">
                <CalendarToday className="userShowIcon" />
                <span className="userShowInfoTitle">10.12.1999</span>
              </div>
              <span className="userShowTitle">Contact Details</span>
              <div className="userShowInfo">
                <PhoneAndroid className="userShowIcon" />
                <span className="userShowInfoTitle">+1 123 456 67</span>
              </div>
              <div className="userShowInfo">
                <MailOutline className="userShowIcon" />
                <span className="userShowInfoTitle">annabeck99@gmail.com</span>
              </div>
              <div className="userShowInfo">
                <LocationSearching className="userShowIcon" />
                <span className="userShowInfoTitle">New York | USA</span>
              </div>
            </div>
          ))}
        </div>
        {/* <div className="userUpdate">
        <span className="userUpdateTitle">Edit</span>
        <form className="userUpdateForm">
            <div className="userUpdateLeft">
            <div className="userUpdateItem">
            <label>Username</label>
            <input
            type="text"
            placeholder="annabeck99"
            className="userUpdateInput"
            />
            </div>
            <div className="userUpdateItem">
                <label>Full Name</label>
                <input
                type="text"
                placeholder="Anna Becker"
                className="userUpdateInput"
                />
                </div>
                <div className="userUpdateItem">
                <label>Email</label>
                <input
                type="text"
                placeholder="annabeck99@gmail.com"
                  className="userUpdateInput"
                />
              </div>
              <div className="userUpdateItem">
              <label>Phone</label>
              <input
              type="text"
              placeholder="+1 123 456 67"
              className="userUpdateInput"
              />
              </div>
              <div className="userUpdateItem">
              <label>Address</label>
              <input
              type="text"
              placeholder="New York | USA"
              className="userUpdateInput"
              />
              </div>
              </div>
              <div className="userUpdateRight">
              <div className="userUpdateUpload">
              <img
                  className="userUpdateImg"
                  src="https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
                  alt=""
                  />
                  <label htmlFor="file">
                  <Publish className="userUpdateIcon" />
                  </label>
                  <input type="file" id="file" style={{ display: "none" }} />
                  </div>
                  <button className="userUpdateButton">Update</button>
                  </div>
                  </form>
                </div> */}
      </div>
    </div>
  );
}
